import { render, staticRenderFns } from "./AnxIcon.vue?vue&type=template&id=a1b355ac&scoped=true&"
import script from "./AnxIcon.vue?vue&type=script&lang=ts&"
export * from "./AnxIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AnxIcon.vue?vue&type=style&index=0&id=a1b355ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b355ac",
  null
  
)

export default component.exports